import { BeckyRequestPayload } from '../types/becky'
import { PageJson } from '@wix/thunderbolt-becky-types'
import getPagesJson from './pages/getPagesJson'

const getPayloadWithErrorPage = (payload: BeckyRequestPayload): BeckyRequestPayload => {
	const pageJson = getPagesJson(payload.errorPageId)

	if (!pageJson) {
		return payload
	}

	return {
		...payload,
		pages: {
			...payload.pages,
			[payload.errorPageId!]: new Promise((resolve) => resolve(getPagesJson(payload.errorPageId)!)) as Promise<
				PageJson
			>,
		},
	}
}

export default getPayloadWithErrorPage
